// src/services/OperationService.ts
import axios from 'axios';
import baseURL from '@/API';
import axiosInstance from "@/utils/axiosConfig";

const ENDPOINTS = {
    OPERATIONS: '/items/all_operation'
};

interface ErrorResponse {
    status: number;
    message: string;
}

const OperationService = {
    async getAll({ id, url }: { id: number, url: string }) {
        try {
            // Construire l'URL complète
            let fullUrl;
            if (url.startsWith('http')) {
                fullUrl = url;
            } else {
                // Retirer le ? du début de url s'il existe
                const cleanUrl = url.startsWith('?') ? url.substring(1) : url;
                // Utiliser l'endpoint DataTable spécifique
                fullUrl = `${baseURL}${ENDPOINTS.OPERATIONS}/${id}/?${cleanUrl}`;
            }
            
            // Détecter si c'est un export (Excel/CSV)
            const isExport = url.includes('export=excel') || url.includes('export=csv');
            
            // Si c'est un export, on attend un blob (fichier binaire)
            const response = await axiosInstance.get(fullUrl, {
                ...(isExport && { responseType: 'blob' })
            });
            
            // Si c'est un export, retourner directement la réponse blob
            if (isExport) {
                return response;
            }
            
            // Sinon, retourner les données formatées pour le DataTable
            return {
                data: response.data.data || response.data.results,
                totalRows: response.data.recordsFiltered || response.data.count,
                recordsFiltered: response.data.recordsFiltered || response.data.count,
                recordsTotal: response.data.recordsTotal || response.data.count,
                draw: response.data.draw
            };
        } catch (error: any) {
            const errorMessage = error.response?.data?.message || error.message || 'An unknown error occurred';
            throw new Error(errorMessage);
        }
    },
};

export default OperationService;
